<template>
  <div class="">
      <div class="flex flex-wrap items-center justify-between gap-4 py-2">
        <div class="flex flex-wrap gap-4">
          <div class="w-1/5 min-w-[200px] pr-5 text-xs py-2">
            Search (User Email)
            <v-text-field placeholder="Name" variant="outlined" density="compact" v-model="searchData" rounded="0">
            </v-text-field>
          </div>
          <div class="w-1/5 min-w-[200px] pr-5 text-xs py-2">
            Location Type
            <v-select v-model="selectedTypeStatus" :items="typeStatusList" density="compact" variant="outlined"
              rounded="0" placeholder="Select Sale Status">
            </v-select>
          </div>
        </div>

        <div class="text-xs py-2">
          <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteNewLocations"
            class="mr-5 bg-dark text-light"></v-btn>
        </div>
      </div>
      <v-data-table 
        :headers="headers" 
        :items="NewLocations.filter(newLocation => newLocation.user.toLowerCase().includes(searchData.toLowerCase()) && (selectedTypeStatus === 'All' || selectedTypeStatus === newLocation.type))" 
        item-key="name" 
        class="border h-[500px] bg-white text-black min-h-[500px] "
        items-per-page="-1"
        style="font-size: 13px;" 
        :style="`height: ${computedHeight}px;`"
      >
          <template v-slot:[`item.no`]="{ index }">
              {{ index + 1 }}
          </template>
          <template v-slot:[`item.checkbox`]="{ item }">
              <div @click="toggleSelection(item)" class="ml-auto align-self-center"
                  style="width: 20px; height: 20px; cursor: pointer;">
                  <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />
              </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div class="flex items-center">
                <v-icon icon="mdi-circle" size="15" :color="item.status === 'DELIVERED' ? 'green' : 'red'"
                    class="mr-2"></v-icon>
                {{ item.status }}
            </div>
          </template>
          <template v-slot:[`item.contact`]="{ item }">
            <a class="flex flex-row items-center gap-x-2 px-3" :href="formatTgLink(item.contact)" target="_blank">
              <img class="w-[30px] h-[30px]" src="../../../assets/tg.png" />
            </a>
          </template>
          <template v-slot:[`item.buttonBar`]="{ item }">
              <v-menu offset-y location="bottom">
                  <template v-slot:activator="{ props, on, isActive }">
                      <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                          :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                          style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                          Actions
                          <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                      </v-btn>
                  </template>
                  <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                      style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                      <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                          rounded="0" class="text-center bg-dark text-light"
                          style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;">
                          {{button }}
                      </v-btn>
                  </v-list>
              </v-menu>
          </template>
      </v-data-table>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useAdminNewLocationStore } from "@/stores"
import { storeToRefs } from 'pinia';

const typeStatusList = ref(['All', 'Location', 'Stock'])

const headers = ref(
  [
      { title: 'No', align: 'center', key: 'no' },
      { title: '', align: 'center', key: 'checkbox' },
      { title: 'ISP', align: 'center', key: 'isp' },
      { title: 'Country', align: 'center', key: 'country' },
      { title: 'State/City', align: 'center', key: 'city' },
      { title: 'How soon?', align: 'center', key: 'period' },
      { title: 'User Email', align: 'center', key: 'user' },
      { title: 'Contact', align: 'center', key: 'contact' },
      { title: 'Max Quantity', align: 'center', key: 'quantity' },
      { title: 'Type', align: 'center', key: 'type' },
      { title: 'Status', align: 'center', key: 'status' },
      { title: 'Request Date', align: 'center', key: 'request_date' },
      { title: 'Actions', align: 'center', key: 'buttonBar' },
  ]
);
const adminNewLocationStore = useAdminNewLocationStore()
const { NewLocations } = storeToRefs(adminNewLocationStore)
adminNewLocationStore.loadNewLocations();

const selectedTypeStatus = ref('All');
const selectedItems = ref([]);
const searchData = ref('')
const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize);
});

const formatTgLink = (tglink) => {
    if(tglink) {
    const cleanedID = tglink.replace(/(@|https?:\/\/t\.me\/)/g, "").trim();
    const telegramUrl = `https://t.me/${cleanedID}`;
    return telegramUrl;
    } else return ''
}

const isSelected = (item) => {
  return selectedItems.value.includes(item);
};

const toggleSelection = (item) => {
  const index = selectedItems.value.indexOf(item);
  if (index === -1) {
      selectedItems.value.push(item);
  } else {
      selectedItems.value.splice(index, 1);
  }
};

const deleteNewLocations = () => {
  adminNewLocationStore.deleteNewLocations(selectedItems.value.map(item => item.id)).then(() => {
    adminNewLocationStore.loadNewLocations()
  })
}

const actionButtons = ref(
  ["Delivery", "Delete"]
)

const selectedItem = ref(null)

const clickAction = (item, button) => {
  switch (button) {
    case "Delivery":
      adminNewLocationStore.deliveryNewLocation(item.id).then(() => {
        adminNewLocationStore.loadNewLocations()
      })
      break
    case "Delete":
      adminNewLocationStore.deleteNewLocations([item.id]).then(() => {
        adminNewLocationStore.loadNewLocations()
      })
  }
}
</script>